module.exports = "<prg-grouped-list [source]=\"(deviceEvents | async | creator:creatorFilter | matchingSearchText:(searchText | async) | groupByRoom | sortBy:'name')\"></prg-grouped-list>\n<!-- BZ#30768 -->\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/list-by-room/list-by-room.component.html
// module id = 1551
// module chunks = 2